import { useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { Input, SelectSimple } from "@components/Input";
import Auth from "components/Accordion/AccordionIntents/extensions/auth";
import Body from "components/Accordion/AccordionIntents/extensions/body";
import Headers from "components/Accordion/AccordionIntents/extensions/headers";
import Prompt from "components/Accordion/AccordionIntents/extensions/prompt";


export const Extensions = (props) => {
  const { isFlow, intent, updateIntent, updateVariables, t } = props;

  const [value, setValue] = useState(0);
  const [timeout, setTimeout] = useState(0);
  const [timeoutError, setTimeoutError] = useState("");

  useEffect(() => {
    if (
      intent.extension?.auth &&
      (!intent.extensions.body?.type ||
        typeof intent.extensions.body !== "object")
    ) {
      intent.extensions.body = {
        type: "application/json",
        payload: intent.extensions.body,
      };

      updateIntent(intent);
    }
    const parseVariablesDeskToState = (variables_desk = []) =>
      variables_desk.map((item) => ({
        variable: item?.name?.replace("$.", "") ?? "",
        equivalence: [],
        zendesk_ticket_field: item?.zendesk_ticket_field ?? {},
      }));

    const variables = parseVariablesDeskToState(
      intent.extensions?.variables_desk
    );
    updateVariables(variables);
  }, []);

  const updateExtension = (e, type) => {
    intent.extensions[type] = e?.target?.value ?? e;
    if (type === "method" && e === "GET") {
      intent.extensions.body = "";
    }
    updateIntent(intent);
  };

  const updateAuthExtension = (e, type) => {
    const value = e?.target?.value ?? e;

    if (type === "access_key") {
      if (value.match(/^[\.a-zA-Z0-9_-]*$/gm)) {
        intent.extensions.auth.access_key_input = value;
        intent.extensions.auth.access_key = `$.${value}`;
      }
    } else {
      intent.extensions.auth[type] = value;
    }

    if (type === "type") {
      intent.extensions.auth.method = e === "jwt" ? "POST" : null;
    }
    updateIntent(intent);
  };

  const handleTabs = (type) => {
    switch (type) {
      case "body":
        setValue(0);
        break;
      case "auth":
        setValue(1);
        break;
      case "header":
        setValue(2);
        break;
      default:
        setValue(0);
        break;
    }
  };

  const handleTimeoutChange = (e) => {
    const value = e.target.value.trim();
    const numericValue = Number(value);
    const onlyNumbers = /^\d*$/;
    if (!onlyNumbers.test(value)) {
      t(
        "intents.config.accordion.extensions.content.valid_letter"
      );
      return;
    }

    if (value === "" && intent?.extensions?.timeout === "") {
      setTimeout(15);
      setTimeoutError("");

      intent.extensions.timeout = 15;
      updateIntent(intent);
    } else if (value === "") {
      delete intent.extensions.timeout;
      updateIntent(intent);
    } else if (
      !isNaN(numericValue) &&
      numericValue >= 0 &&
      numericValue <= 60
    ) {
      setTimeout(numericValue);
      setTimeoutError("");

      intent.extensions.timeout = numericValue;
      updateIntent(intent);
    } else {
      setTimeoutError(
        t("intents.config.accordion.extensions.content.only_number")
      );
    }
  };
  return (
    <div className={"accordion__content"}>
        <div className={"accordion__element_extension"}>
          <Grid container spacing={2}>
            <Grid item xs={9}>
              <div className={"accordion__element_extension_header"}>
                {/* METHOD SELECTOR */}
                <SelectSimple
                  valueSelected={
                    intent.extensions.method ? intent.extensions.method : false
                  }
                  items={["GET", "POST", "PUT", "PATCH", "DELETE"]}
                  onSelect={(e) => {
                   updateExtension(e, "method");
                  }}
                  placeholder={t(
                    "intents.config.accordion.extensions.content.method"
                  )}
                  type={"method"}
                  t={t}
                  className={`${!isFlow ? "" : "select_secondary nodrag"}`}
                />
                {/* URL */}
                <Input
                  onChange={(e) => {
                    updateExtension(e, "url");
                  }}
                  value={intent.extensions.url}
                  type={"secondary"}
                  placeholder={t(
                    "intents.config.accordion.extensions.content.url"
                  )}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Grid
                container
                alignItems="center"
                style={{
                  backgroundColor: "white",
                  width: "100%",
                  height: "40px",
                  borderRadius: "5px",
                }}
              >
                <Grid item xs={12} sm={7} md={7}>
                  <Typography
                    variant="body2"
                    style={{
                      marginLeft: "10px",
                      color: "#565671",
                      marginBottom: timeoutError ? "42px" : "0",
                    }}
                  >
                    {t("intents.config.accordion.extensions.content.timeout")}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={5}
                  md={5}
                  style={{ backgroundColor: "#f5f5f5" }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      border: "1px solid #f0eaea",
                      borderRadius: "4px",
                      backgroundColor: "#fff",
                      justifyContent: "space-between",
                    }}
                  >
                    <Input
                      id="timeoutInput"
                      placeholder="15"
                      type={"secondary"}
                      inputProps={{ maxLength: 2 }}
                      value={intent?.extensions?.timeout}
                      onChange={handleTimeoutChange}
                      style={{
                        border: "none",
                        paddingLeft: "10px",
                        width: "60%",
                      }}
                    />
                    <Typography
                      variant="body2"
                      style={{
                        margin: "0 6px",
                        width: "30%",
                        color: "#565671",
                      }}
                    >
                      {t("intents.config.accordion.extensions.content.seconds")}
                    </Typography>
                  </div>
                  {timeoutError && (
                    <span
                      className={"error"}
                      style={{ fontSize: "12px", display: "block" }}
                    >
                      {timeoutError}
                    </span>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <div className={"accordion__element_extension_tabs"}>
            <div className={"accordion__element_extension_tabs_panels"}>
              <div
                className={`accordion__element_extension_tabs_panel ${
                  value === 0 ? "active" : ""
                }`}
                onClick={() => {
                  handleTabs("body");
                }}
              >
                <span>BODY</span>
              </div>
              <div
                className={`accordion__element_extension_tabs_panel ${
                  value === 1 ? "active" : ""
                }`}
                onClick={() => {
                  handleTabs("auth");
                }}
              >
                <span>AUTH</span>
              </div>
              <div
                className={`accordion__element_extension_tabs_panel ${
                  value === 2 ? "active" : ""
                }`}
                onClick={() => {
                  handleTabs("header");
                }}
              >
                <span>HEADER</span>
              </div>
            </div>
            <div className={"accordion__element_extension_tabs_elements"}>
              <div className={"accordion__element_extension_tabs_element"}>
                {value === 0 && <Body {...props} />}
                {value === 1 && (
                  <Auth
                    {...props}
                    updateAuthExtension={updateAuthExtension}
                  />
                )}
                {value === 2 && <Headers {...props} />}
              </div>
            </div>
          </div>

          {/* PROMPT */}
          <Prompt {...props} updateExtension={updateExtension} />
        </div>
     
    </div>
  );
};

